import SettingScreen from "features/Setting/SettingScreen";
import React from "react";

function Setting({ icon }) {
  return <SettingScreen />;
}

export default Setting;
